import axios from "axios";
// import Vue from "vue";
import router from "./router";

// if()
axios.defaults.baseURL = process.env.VUE_APP_SMEGP_BASE_API;

function getAuthType() {
  const store = router.app.$store;

  if (store.getters["govAuthen/isAuthenticate"]) return "government";
  if (store.getters["authen/getToken"]) return "user";

  return null;
}

export function jwtInterceptor() {
  //add a request interceptor
  axios.interceptors.request.use(
    (config) => {
      if (config.url != "https://api.ipify.org/?format=json") {
        if (!config.headers["Content-Type"]) config.headers["Content-Type"] = "application/json";
        const authType = getAuthType();
        // if (!config.headers["Authorization"] && router.app.$store.getters["authen/getToken"]) {
        //   config.headers["Authorization"] = `Bearer ${router.app.$store.getters["authen/getToken"]}`;
        // }
        
        if (!config.headers["Authorization"]) {
          // config.headers["Authorization"] = `Bearer ${router.app.$store.getters["authen/getToken"]}`;
          if (authType === "user") {
            config.headers["Authorization"] = `Bearer ${router.app.$store.getters["authen/getToken"]}`;
          }

          if (authType === "government") {
            config.headers["Authorization"] = `Bearer ${router.app.$store.getters["govAuthen/getToken"]}`;
          }
        }
      }
      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );
  // Add a response interceptor
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const originalRequest = error.config;
      const authType = getAuthType();

      if (
        authType === "user" &&
        error.response.status == 500 &&
        error.response.data.message === "jwt expired" &&
        !originalRequest._retry &&
        !error.config.url.includes("auth/access_token")
      ) {
        originalRequest._retry = true;
        await router.app.$store.dispatch("authen/fetchAccessToken", { isRefresh: true });
        originalRequest.headers["Authorization"] = `Bearer ${router.app.$store.getters["authen/getToken"]}`;
        return axios(originalRequest);
      }

      if (
        authType === "government" &&
        ( error.response.status === 401 &&
          error.response.data?.message === "Unauthorized"
        )
      ) {
        await router.app.$store.dispatch("govAuthen/logout");

        router.replace({ name: "governmentLogin" });
        return Promise.reject(error);
      }

      return Promise.reject(error);
    }
  );
}
